import React from 'react';
import { Dialog } from '@mui/material';
import { CancelDialog } from 'components/common/Dialog/CancelDialog';
import IMG_DELETE from 'assets/img_1.png';
import IMG_RESEND from 'assets/bill-1.png';

const COPY = {
  delete: {
    img: IMG_DELETE,
    title: 'Are you sure you want to delete this email?',
    detail: 'This invitation will be permanently removed from the list.',
    yesLabel: 'Yes, delete',
    confirmVariant: 'destructive',
  },
  resend: {
    img: IMG_RESEND,
    title: 'Are you sure you want to resend this email?',
    detail: 'A new invitation email will be sent to the recipient.',
    yesLabel: 'Yes, resend',
    confirmVariant: 'primary',
  },
};

export const InvitationConfirmDialog = ({
  type,
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => {
  const copy = COPY[type] || COPY.resend;

  return (
    <Dialog open={open} onClose={isSubmitting ? undefined : onClose} maxWidth={false}>
      <CancelDialog
        img={copy.img}
        title={copy.title}
        detail={copy.detail}
        noFunc={onClose}
        yesFunc={onConfirm}
        isSubmitting={isSubmitting}
        yesLabel={copy.yesLabel}
        noLabel="Discard"
        confirmVariant={copy.confirmVariant}
      />
    </Dialog>
  );
};
